import { render } from "./LangSelect.vue?vue&type=template&id=458ca3b4&scoped=true"
import script from "./LangSelect.vue?vue&type=script&lang=js"
export * from "./LangSelect.vue?vue&type=script&lang=js"

import "./LangSelect.vue?vue&type=style&index=0&id=458ca3b4&scoped=true&lang=css"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458ca3b4"]])

export default __exports__